export function downloadFile(data: BlobPart, name: string, type: string) {
    const url = window.URL.createObjectURL(
        new Blob([data], {
            type: type,
        }),
    );
    const link = document.createElement('a');
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
